import React from 'react'
import { Link } from 'react-router-dom'

type Props = { className?: string }

/** Commuvity "STL Swing Website Widget". The script that defines the element is loaded in public/index.html */
export const UpcomingEventsWidget = ({ className }: Props) => (
  <div className={className}>
    <signup-widget data-org='1' data-widget='2'></signup-widget>
  </div>
)

export const UpcomingEventsPanel = () => (
  <section id='upcoming-events' className='bg-paper'>
    <div className='max-w-6xl px-4 py-16 mx-auto sm:px-6 sm:py-24'>
      <div className='flex flex-wrap items-baseline justify-between gap-4'>
        <h2 className='h2'>Upcoming events</h2>
        <Link to='/swing-dance-events' className='link'>
          See all events
        </Link>
      </div>
      <UpcomingEventsWidget className='mt-10' />
    </div>
  </section>
)
